import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { GridOn } from "@mui/icons-material";
import "./GridSettings.css";

const GridSettings = ({
  gridSize,
  onSizeChange,
  onCreateGrid,
  disabled = false,
  isGeneratingChart = false,
  inTheRound = false,
  onInTheRoundChange,
}) => {
  const [localSize, setLocalSize] = useState(gridSize);

  useEffect(() => {
    setLocalSize(gridSize);
  }, [gridSize]);

  const handleSizeChange = (field, value) => {
    const newSize = { ...localSize, [field]: parseInt(value) || 1 };
    setLocalSize(newSize);
  };

  const handleCreateGrid = () => {
    if (window.confirm(`Are you sure you want to create a new ${localSize.height}×${localSize.width} grid? This will replace your current chart and all stitches will be lost.`)) {
      onSizeChange(localSize);
      onCreateGrid(localSize);
    }
  };

  return (
    <Box>
      <div className="d-flex align-items-center gap-2 mb-3">
        <GridOn color="primary" />
        <Typography variant="h5" color="primary">
          Grid Settings
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          className="mt-1 mb-0 d-block"
        >
          Min: 2×2, Max: 50×100
        </Typography>
      </div>

      <div className="grid-settings-fields">
        <div className="row g-2 mb-3">
          <div className="col-6">
            <TextField
              label="Height"
              type="number"
              value={localSize.height}
              onChange={(e) => handleSizeChange("height", e.target.value)}
              inputProps={{ min: 2, max: 100 }}
              fullWidth
              size="small"
              className="grid-settings-field"
            />
          </div>
          <div className="col-6">
            <TextField
              label="Width"
              type="number"
              value={localSize.width}
              onChange={(e) => handleSizeChange("width", e.target.value)}
              inputProps={{ min: 2, max: 50 }}
              fullWidth
              size="small"
              className="grid-settings-field"
            />
          </div>
        </div>

        <Button
          variant="contained"
          onClick={handleCreateGrid}
          disabled={disabled || isGeneratingChart}
          fullWidth
          size="small"
          color="primary"
          startIcon={
            isGeneratingChart ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <GridOn />
            )
          }
        >
          {isGeneratingChart
            ? `Generating ${localSize.height}×${localSize.width} Grid...`
            : `Create Grid (${localSize.height}×${localSize.width})`}
        </Button>
      </div>

      {onInTheRoundChange && (
        <FormControlLabel
          control={
            <Checkbox
              checked={inTheRound}
              onChange={(e) => onInTheRoundChange(e.target.checked)}
              size="large"
            />
          }
          label="Knitted in the round"
          className="grid-settings-checkbox"
        />
      )}
    </Box>
  );
};

export default GridSettings;
